import { getRootProductDescription } from "@models";
import { ModuleSetting, rootProductIds, User } from "@models";
import { Currency, getDateFlags } from "@util";
import { endOfDay, isBefore } from "date-fns";
import _ from "lodash";

export function groupModuleSettingsByProduct(moduleSettings: ModuleSetting[]) {
	const current = _(moduleSettings)
		.filter((b) => getDateFlags(b.availableFrom, b.availableUntil).isActive)
		.groupBy((b) => b.category);

	return rootProductIds.map((id) => ({
		id,
		productName: getRootProductDescription(id).name,
		moduleSettings: current.get(id),
	}));
}

export function summarizeMSs(moduleSettings: ModuleSetting[]): string {
	if (!moduleSettings) return "Kein Budget";

	const totalSum = _.sumBy(moduleSettings, (b) =>
		_.sumBy(b.amounts, (a) => a.maxAmountMonth)
	);
	return Currency.format(totalSum);
}

export function getStatusFlags(user: User) {
	return {
		nonTestUser: !user.isTestUser,
		uploadAllowed: user.ownVouchersEnabled,
		salutated: user.salutated,
		contractStarted: isBefore(user.contractStart, new Date()),
		nonExpired:
			user.contractEnd === null ||
			isBefore(new Date(), endOfDay(user.contractEnd)),
		active: user.isActive,
		hasLoggedIn: user.lastLoginMobile || user.lastLoginWeb,
		hasActiveIncident: !!user.activeIncident,
	};
}
